module.exports = __webpack_public_path__ + "static/media/reset-button-hover.6e236f2e.svg";